/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCone2Filled = createReactComponent("filled", "cone-2-filled", "IconCone2Filled", [["path", { "d": "M12 1c5.52 0 10 1.494 10 4.002v.5a1 1 0 0 1 -.121 .477l-8.139 15.006a2 2 0 0 1 -3.489 -.016l-8.13 -14.99a1 1 0 0 1 -.121 -.475v-.5c0 -2.509 4.48 -4.004 10 -4.004", "key": "svg-0" }]]);

export { IconCone2Filled as default };
//# sourceMappingURL=IconCone2Filled.mjs.map
